import { render, staticRenderFns } from "./PatentDetail.vue?vue&type=template&id=98139ab4"
import script from "./PatentDetail.vue?vue&type=script&lang=ts"
export * from "./PatentDetail.vue?vue&type=script&lang=ts"
import style0 from "./PatentDetail.vue?vue&type=style&index=0&id=98139ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports